import React from 'react';

import { Typography } from '@lyearn/ui';

import getTimeAgo from './getTimeAgo';
import { TimeAgoProps } from './types';

function TimeAgo(props: TimeAgoProps) {
  const { time, variant = 'body-short-03', color = 'text-text-secondary', className = '' } = props;
  const formattedTime = React.useMemo(() => getTimeAgo(time), [time]);

  return (
    <Typography className={className} color={color} variant={variant}>
      <time>{formattedTime}</time>
    </Typography>
  );
}

export default React.memo(TimeAgo);
